import { useRouteMatch, Link, useLocation } from 'react-router-dom';
import { useMobileNavigation } from '../MobileNavigation';
import { StyledListItem } from './styled';
export function NavItem(props) {
    const { to, matchExact = false, matchPath, children } = props;
    const match = useRouteMatch(matchPath);
    const { pathname, search } = useLocation();
    const currentUrl = `${pathname}${search}`;
    const fullUrlMatch = matchPath === currentUrl;
    const routeMatch = Boolean(matchExact ? match && match.isExact : match);
    const selected = fullUrlMatch || routeMatch;
    const { close } = useMobileNavigation();
    const handleClick = () => close();
    return (<StyledListItem as={Link} to={to} $selected={selected} onClick={handleClick} aria-selected={selected ? 'true' : undefined}>
      {children}
    </StyledListItem>);
}
